import React from "react";
import Inview from "./inview";

export default class CustomizationCustomBlock extends React.Component {
    render() {
        // to make a banner: remove className `container row` and add class banner
        return (
            <div className="custom-block customization margin-t-l customization-background-image">
                <div className="container margin-xl">
                    <div className="row">
                        <div className="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                            <h1 className="font-xxlarge">
                                Endless Customization
                            </h1>
                            <p className="font-medium weight-light">
                                All Pro downloads get unlimited customizations
                                to make sure your icons fit where you use them.
                                Change the icon color, rotation, flip, and
                                background.
                            </p>
                            <a
                                className="button small green"
                                href="/preview/customize/"
                            >
                                Try it out
                            </a>
                        </div>
                        <div className="col-lg-6 col-md-6 col-sm-6 col-xs-12 padding-m">
                            <img
                                src={require("../../img/homepage/butterfly@2x.png")}
                                alt="Endless Customization"
                                style={{ margin: "auto", display: "block" }}
                                width="250"
                                height="250"
                            />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
